const COLOR_CARD_SELECTOR = 'product-card[data-ibs-color-card="true"]';
const CARD_LINK_REFS = ['productCardLink', 'productTitleLink', 'cardGalleryLink'];

function escapeSelector(value) {
  if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(String(value));
  return String(value).replace(/(["\\])/g, '\\$1');
}

function forceVariantLinks(card) {
  const url = card.dataset.ibsVariantUrl;
  if (!url) return;

  CARD_LINK_REFS.forEach((ref) => {
    card.querySelectorAll(`[ref="${ref}"]`).forEach((link) => {
      if (link instanceof HTMLAnchorElement) link.href = url;
    });
  });
}

function forceVariantMedia(card) {
  const mediaId = card.dataset.ibsInitialMediaId;
  if (!mediaId) return;

  const escapedId = escapeSelector(mediaId);
  const targetSlide = card.querySelector(`slideshow-slide[slide-id="${escapedId}"], [slide-id="${escapedId}"]`);
  if (!(targetSlide instanceof HTMLElement)) return;

  card.querySelectorAll('[variant-image]').forEach((slide) => {
    if (slide instanceof HTMLElement) slide.hidden = slide !== targetSlide;
  });

  const slideshow = targetSlide.closest('slideshow-component');
  if (slideshow && typeof slideshow.select === 'function') {
    try {
      slideshow.select({ id: mediaId }, undefined, { animate: false });
    } catch (_) {
      // The native gallery can still display the unhidden target slide.
    }
  }
}

function applyColorCardState(card) {
  forceVariantLinks(card);
  forceVariantMedia(card);
}

function initColorCard(card) {
  if (!(card instanceof HTMLElement) || card.dataset.ibsColorCardInitialized === 'true') return;
  card.dataset.ibsColorCardInitialized = 'true';

  forceVariantLinks(card);

  const apply = () => requestAnimationFrame(() => applyColorCardState(card));

  if (customElements.get('slideshow-component')) {
    apply();
  } else {
    customElements.whenDefined('slideshow-component').then(apply).catch(() => {});
  }

  // Dwell resets the image after a hover preview. Restore the color represented by this card.
  card.addEventListener('pointerleave', apply, { passive: true });
  card.addEventListener('focusout', (event) => {
    if (event.relatedTarget instanceof Node && card.contains(event.relatedTarget)) return;
    apply();
  });
}

function scan(root = document) {
  if (root instanceof Element && root.matches(COLOR_CARD_SELECTOR)) initColorCard(root);
  root.querySelectorAll?.(COLOR_CARD_SELECTOR).forEach(initColorCard);
}

scan(document);

const main = document.querySelector('#MainContent') || document.querySelector('main') || document.body;
if (main) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) scan(node);
      });
    });
  });
  observer.observe(main, { childList: true, subtree: true });
}

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) scan(event.target);
});
